import React from "react";
import { WithAPICall } from "../utils/apiUtil";
import {
  Alert,
  Card,
  LinearProgress,
  Paper,
  Button,
  Typography,
  Fab,
} from "@mui/material";
import { View500 } from "src/sections/error";
import { Box, Stack } from "@mui/system";
import InputBox from "./InputBox";
import Markdowner from "./Markdowner";
import cogoToast from "cogo-toast";
import Iconify from "src/components/iconify";
import { copyToClipboard } from "../utils/fn";
import AsstMessage from "./AsstMessage";

class Thread extends React.Component {
  constructor(props) {
    super(props);
    this.messagesEndRef = React.createRef();
  }
  state = {
    isLoading: true,
    isError: false,
    currentUser: null,
    messages: [],
    isStreaming: false,
    streamingResponse: "",
    streamingResponseArr: [],
    hovering: false,
    isSharing: false,
  };
  buffer = "";
  bufferArr = [];
  timer = null;
  timerArr = null;
  componentDidMount() {
    this.getUser();
  }
  componentDidUpdate(prevProps, prevState) {
    this.scrollToBottom();
  }
  scrollToBottom = () => {
    if (this.messagesEndRef.current) {
      this.messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  getUser = async () => {
    try {
      let r = await this.props.apiCallPost("/harley/getCurrentUser", {});
      this.setState({ currentUser: r }, () => {
        this.getThreadById();
      });
    } catch (error) {
      this.setState({ currentUser: null, isLoading: false, isError: true });
    }
  };
  getThreadById = async () => {
    const { id } = this.props;
    try {
      const response = await this.props.apiCallPost(`/harley/getThreadById`, {
        threadId: id,
      });

      this.setState({
        isLoading: false,
        ...response,
        isStreaming: false,
        streamingResponse: "",
      });
      this.buffer = "";
      this.bufferArr = [];
      this.timer = null;
      this.timerArr = null;
    } catch (error) {
      this.setState({ isLoading: false, isError: true });
    }
  };
  streamNextResponse = async () => {
    this.setState({
      isStreaming: true,
      streamingResponse: "",
    });
    this.buffer = "";
    this.timer = setInterval(() => {
      let bufferLength = this.buffer.length;
      let loadedDataLength = this.state.streamingResponse.length;
      let diff = bufferLength - loadedDataLength;
      let slice = this.buffer.substring(
        parseInt(loadedDataLength),
        parseInt(bufferLength)
      );
      if (diff > 0) {
        this.setState({
          streamingResponse:
            this.state.streamingResponse +
            this.buffer.slice(loadedDataLength, bufferLength),
        });
      }
    }, 100);
    try {
      let r = await this.props.apiCallPostStreamingForAI(
        "/harley/streamNextResponse",
        {
          threadId: this.props.id,
        },
        (data) => {
          this.buffer = this.buffer.concat(data);
        },
        () => {
          this.onEnd();
        }
      );
    } catch (err) {
      cogoToast.error("Error streaming response");
    }
  };
  streamNextAssistantResponse = async () => {
    this.setState({
      isStreaming: true,
      streamingResponse: "",
      streamingResponseArr: [],
    });
    this.bufferArr = [];
    this.timerArr = setInterval(() => {
      let bufferLength = this.bufferArr.length;
      let loadedDataLength = this.state.streamingResponseArr.length;
      let diff = bufferLength - loadedDataLength;

      if (diff > 0) {
        let elemsToConsider = this.bufferArr.slice(
          loadedDataLength,
          bufferLength
        );

        let csr = this.state.streamingResponse || "";
        for (var i = 0; i < elemsToConsider.length; i++) {
          let obj = elemsToConsider[i];
          let event = obj.event;
          let strToAdd = "";
          let CODE_INIT = "\n## Writing Code\n\n```\n";
          let CODE_END = "\n```\n### Code execution completed!\n\n";
          if (event === "thread.run.step.in_progress") {
            if (obj.data.step_details.tool_calls?.length > 0) {
              if (
                obj.data.step_details.tool_calls[0].type === "code_interpreter"
              ) {
                strToAdd = CODE_INIT;
              }
            }
            // if (obj.toolCall && obj.toolCall.type === "code_interpreter") {
            // }
          }
          if (event === "thread.run.step.completed") {
            if (obj.data.step_details.tool_calls?.length > 0) {
              if (
                obj.data.step_details.tool_calls[0].type === "code_interpreter"
              ) {
                strToAdd = CODE_END;
              }
            }
            // check if immediately before this CODE_END, if so, first add 1 line then CODE_INIT then add obj.input
            // strToAdd = "\n" + CODE_END;
            // let last = csr.slice(-CODE_END.length);
            // if (last === CODE_END) {
            //   strToAdd = "\n" + CODE_INIT;
            // } else {
            //   strToAdd = obj.input;
            // }
          }
          // if (event === "toolCallDone") {
          //   if (
          //     obj.toolCallDone &&
          //     obj.toolCallDone.type === "code_interpreter"
          //   ) {
          //     strToAdd = CODE_END;
          //   }
          // }
          // if (event === "textCreated") {
          //   let strToAdd;
          //   if (csr.length < CODE_END.length) {
          //     strToAdd = "\n\n";
          //   } else {
          //     let last = csr.slice(-CODE_END.length);
          //     if (last === CODE_END) {
          //       strToAdd = "\n\n";
          //     } else {
          //       strToAdd = CODE_END;
          //     }
          //   }
          // }
          if (event === "thread.message.delta") {
            for (const content of obj.data.delta.content) {
              if (content.type === "text") {
                strToAdd += content.text.value;
              }
            }
            // strToAdd = obj.value;
          }
          if (event === "thread.run.step.delta") {
            for (const content of obj.data.delta.step_details.tool_calls) {
              if (content.type === "code_interpreter") {
                if (content.code_interpreter.input) {
                  strToAdd += content.code_interpreter.input;
                } else if (content.code_interpreter.outputs) {
                  const output = content.code_interpreter.outputs.map(
                    (o) => o.logs + "\n"
                  );
                  strToAdd += output;
                }
              }
            }
          }
          if (strToAdd) {
            csr = csr + strToAdd;
          }
        }

        // console.log("CSR>>>>", csr);

        this.setState({
          streamingResponse: csr,
          streamingResponseArr: [
            ...this.state.streamingResponseArr,
            ...this.bufferArr.slice(loadedDataLength, bufferLength),
          ],
        });
      }
    }, 100);
    try {
      await this.props.apiCallPostStreaming(
        "/harley/streamNextAssistantResponse",
        {
          threadId: this.props.id,
        },
        (data) => {
          this.bufferArr.push(...data);
        },
        () => {
          this.onEnd(true);
        }
      );
    } catch (err) {
      cogoToast.error("Error streaming response");
    }
  };
  pollNextResponse = async () => {
    try {
      this.setState({
        isStreaming: true,
        streamingResponse: "",
      });
      let r = await this.props.apiCallPost("/harley/pollNextResponse", {
        threadId: this.props.id,
      });
      this.setState({
        isStreaming: false,
        ...r,
      });
    } catch (err) {
      this.setState({
        isStreaming: false,
      });
      cogoToast.error("Error polling next response");
    }
  };
  onEnd = async (asst = false) => {
    // wait 2 seconds
    await new Promise((r) => setTimeout(r, asst ? 3000 : 1000));
    clearInterval(this.timer);
    clearInterval(this.timerArr);

    this.getThreadById();
  };
  shareThread = async () => {
    try {
      this.setState({
        isSharing: true,
      });
      let r = await this.props.apiCallPost("/harley/shareThread", {
        threadId: this.props.id,
      });

      this.setState({
        isSharing: false,
        hovering: false,
      });
    } catch (error) {
      this.setState({
        isSharing: false,
      });
      cogoToast.error("Error sharing thread");
    }
  };
  renderMessages = () => {
    // IF NO MESSAGE
    if (!this.state.messages.length) {
      return (
        <div
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Alert severity="info">
            No messages yet. Get started by typing or speaking below.
          </Alert>
        </div>
      );
    }
    return (
      <Stack spacing={2}>
        {this.state.messages.map((x) => {
          let role = x.role;
          let content = x.content;
          if (role === "user") {
            return (
              <Card
                sx={{
                  p: 1,
                  m: 1,
                  bgcolor: "background.neutral",
                  borderRadius: 2,
                  boxShadow: 3,
                }}
              >
                <Stack>
                  <Typography variant="overline">
                    {this.state.userId?.name || "User"}
                  </Typography>

                  {content.map((c) => {
                    let type = c.type;
                    if (type === "text") {
                      return (
                        <Markdowner
                          text={this.transformLatexDelimiters(c.text)}
                        />
                      );
                    }
                    if (type === "data_url") {
                      return (
                        <Box>
                          {" "}
                          <Button
                            href={c.data_url.url}
                            download
                            color="success"
                            startIcon={<Iconify icon="mdi:download" />}
                          >
                            {c.data_url.filename}
                          </Button>
                        </Box>
                      );
                    }
                    if (type === "image_url") {
                      return (
                        <Box
                          sx={{
                            maxWidth: "600px",
                          }}
                        >
                          <img src={c.image_url.url} alt="IMAGE" />
                        </Box>
                      );
                    }
                  })}
                </Stack>
              </Card>
            );
          }
          if (role === "assistant") {
            let mode = this.state.conversationType;
            let isCompletion = mode === "completion";
            if (isCompletion) {
              let content = x.content;
              if (!content) {
                return null;
              }
              return (
                <AsstMessage
                  message={x}
                  threadId={this.props.id}
                  isUnAuth={false}
                />
              );
            }

            return (
              <Card
                sx={{
                  p: 1,
                  m: 1,
                  bgcolor: "background.paper",
                  borderRadius: 2,
                  boxShadow: 3,
                }}
              >
                <Stack>
                  <Typography variant="overline">Harley</Typography>
                  {content.map((c) => {
                    let type = c.type;
                    if (type === "text") {
                      if (typeof c.text === "string") {
                        return (
                          <Markdowner
                            text={this.transformLatexDelimiters(c.text)}
                          />
                        );
                      }
                      let hasAnnotations = c.text.annotations
                        ? !!c.text.annotations.length
                        : false;
                      let annotations = [];
                      if (hasAnnotations) {
                        annotations = c.text.annotations;
                      }
                      return (
                        <Markdowner
                          text={this.transformLatexDelimiters(c.text.value)}
                          annotations={annotations}
                          isAsst={this.state.conversationType === "assistant"}
                        />
                      );
                    }
                    if (type === "image_file") {
                      let fileId = c.image_file.file_id;
                      let url = `/harley/GeneratedImage/${fileId}`;
                      let apiUrl = process.env.REACT_APP_API_URL;
                      let imageUrl = `${apiUrl}${url}`;
                      return (
                        <Box
                          sx={{
                            maxWidth: "600px",
                          }}
                        >
                          <img src={imageUrl} alt="IMAGE" />
                        </Box>
                      );
                    }
                  })}
                </Stack>
              </Card>
            );
          }
        })}
      </Stack>
    );
  };

  transformLatexDelimiters = (text) => {
    // Handle inline LaTeX delimiters: \( ... \)
    text = text.replace(/\\\((.*?)\\\)/g, (_, match) => `$${match}$`);

    // Handle display mode LaTeX delimiters: \[ ... \]
    text = text.replace(/\\\[(.*?)\\\]/g, (_, match) => `$$${match}$$`);

    // Handle display mode LaTeX delimiters with extra backslashes: \\[ ... \\]
    text = text.replace(/\\\\\[(.*?)\\\\\]/g, (_, match) => `$$${match}$$`);

    // Handle inline LaTeX delimiters with extra backslashes: \\( ... \\)
    text = text.replace(/\\\\\((.*?)\\\\\)/g, (_, match) => `$${match}$`);

    // Handle LaTeX delimiters with spaces: $ ... $
    text = text.replace(/\$(.*?)\$/g, (_, match) => `$${match}$`);

    // Handle LaTeX delimiters with double dollar signs: $$ ... $$
    text = text.replace(/\$\$(.*?)\$\$/g, (_, match) => `$$${match}$$`);

    return text;
  };

  renderStreamingResponse = () => {
    if (!this.state.isStreaming) {
      return null;
    }
    if (!this.state.streamingResponse && this.state.isStreaming) {
      return null;
    }
    return (
      <Card
        sx={{
          p: 1,
          m: 1,
          bgcolor: "#D4F17E",
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Stack spacing={2}>
          <Typography variant="overline">Harley</Typography>
          <Markdowner
            text={this.transformLatexDelimiters(this.state.streamingResponse)}
          />
        </Stack>
      </Card>
    );
  };
  renderInputArea = () => {
    return (
      <InputBox
        disabled={this.state.isStreaming}
        threadId={this.props.id}
        conversationType={this.state.conversationType}
        onAddMessage={(res) => {
          this.setState(
            {
              ...res,
            },
            () => {
              let conversationType = this.state.conversationType;
              if (conversationType === "assistant") {
                //this.pollNextResponse();
                this.streamNextAssistantResponse();
              } else {
                this.streamNextResponse();
              }
            }
          );
        }}
      />
    );
  };
  renderOverall = () => {
    return (
      <Stack
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "90dvh",
          overflow: "hidden",
          width: "95%",
          margin: "auto",
          alignContent: "flex-end",
        }}
      >
        {" "}
        <Paper
          sx={{
            padding: 2,
            overflowY: "scroll",
            height: "80%",
          }}
        >
          {this.renderMessages()}
          {this.renderStreamingResponse()}
          <div ref={this.messagesEndRef} />
        </Paper>
        <Paper sx={{ padding: 2, height: "20%" }}>
          {this.renderInputArea()}
        </Paper>
      </Stack>
    );
  };
  renderFAB = () => {
    let messages = this.state.messages;
    if (!messages.length || messages.length < 2) {
      return null;
    }
    if (this.state.isSharing) {
      return (
        <Fab
          disabled={this.state.isSharing}
          size="small"
          color="warning"
          style={{
            position: "fixed",
            bottom: "60%",
            right: "10px",
          }}
        >
          <Iconify icon="svg-spinners:blocks-shuffle-3" />
        </Fab>
      );
    } else if (this.state.hovering) {
      return (
        <Fab
          disabled={this.state.isSharing || this.state.isStreaming}
          onMouseLeave={() => {
            this.setState({ hovering: false });
          }}
          size="small"
          color="success"
          variant="extended"
          onClick={(e) => {
            let url = `https://harley.newchart.care/${this.props.id}`;
            copyToClipboard(url)
              .then(() => {
                cogoToast.success("Link copied to clipboard");
              })
              .catch((error) => {
                cogoToast.error(
                  "Failed to copy URL. This is an iOS issue. Please share the URL directly."
                );
              });
            this.shareThread();
          }}
          style={{
            position: "fixed",
            bottom: "60%",
            right: "10px",
            p: 1,
          }}
        >
          <Iconify icon="mi:share" /> Share
        </Fab>
      );
    } else {
      return (
        <Fab
          disabled={this.state.isSharing || this.state.isStreaming}
          onMouseEnter={() => {
            this.setState({ hovering: true });
          }}
          size="small"
          color="secondary"
          style={{
            position: "fixed",
            bottom: "60%",
            right: "10px",
          }}
        >
          <Iconify icon="mi:share" />
        </Fab>
      );
    }
  };

  render() {
    if (this.state.isLoading) {
      return <LinearProgress />;
    }
    if (this.state.isError) {
      return <View500 />;
    }
    return (
      <div>
        <Markdowner text={this.aa} />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            overflow: "hidden",
          }}
        >
          {this.renderOverall()}
        </div>{" "}
        <Box sx={{ "& > :not(style)": { m: 1 } }}>{this.renderFAB()}</Box>{" "}
      </div>
    );
  }
}

export default WithAPICall(Thread);
